var modal = {
  "adapter-loader.message": "Verify your {{adapter}} account to continue",
  "adapter-loader.message1": "Verify your {{adapter}}",
  "adapter-loader.message2": "account to continue",
  "errors-invalid-email": "Invalid Email",
  "errors-invalid-number": "Invalid Phone Number",
  "errors-invalid-number-email": "Invalid Email or Phone Number",
  "errors-required": "Required",
  "external.back": "Back",
  "external.connect": "Continue with a wallet",
  "external.search-text": "Don't see your wallet?",
  "external.search-subtext": "Try search instead",
  "external.connect-wallet": "Connect Wallet",
  "external.continue": "Continue with external wallet",
  "external.dont-have": "Don't have",
  "external.get": "Get",
  "external.get-wallet": "Get Wallet",
  "external.install-browser-extension": "Install {{browser}} extension",
  "external.install-mobile-app": "Install {{os}} app",
  "external.installed": "Installed",
  "external.no-wallets-found": "No wallets found",
  "external.search-wallet": "Search through {{count}} wallets...",
  "external.title": "External Wallet",
  "external.walletconnect-connect": "Connect",
  "external.walletconnect-copy": "Scan with a WalletConnect-supported wallet or click the QR code to copy to your clipboard.",
  "external.walletconnect-subtitle": "Scan the QR code with a WalletConnect-compatible wallet",
  "footer.message": "Self-custodial login by",
  "footer.message-new": "Self-custody via",
  "footer.policy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.terms-service": "Terms of Service",
  "footer.version": "Version",
  "header-subtitle": "Select one of the following options to continue",
  "header-subtitle-name": "Your {{appName}} wallet with one click",
  "header-subtitle-new": "Your blockchain wallet with one click",
  "header-title": "Sign in",
  "header-tooltip-desc": "The wallet serves as an account to store and manage your digital assets on the blockchain.",
  "header-tooltip-title": "Wallet",
  "network.add-request": "This site is requesting to add a network",
  "network.cancel": "Cancel",
  "network.from": "From",
  "network.proceed": "Proceed",
  "network.switch-request": "This site is requesting to switch networks",
  "network.to": "To",
  "passkey.add": "Add Passkey",
  "passkey.haveExisting": "Have an existing passkey?",
  "passkey.learn-more": "Learn more",
  "passkey.or": "or",
  "passkey.register-desc": "With passkeys, you can verify your identity through your face, fingerprint, or security keys.",
  "passkey.register-title": "Register Passkey",
  "passkey.use": "I have a passkey",
  "popup.phone-body": "Your country code will be detected automatically, but if you're using a phone number from a different country, you'll need to enter the correct country code manually.",
  "popup.phone-header": "Phone number and country code",
  "post-loading.connected": "You are connected with your account",
  "post-loading.something-wrong": "Something went wrong!",
  "social.continue": "Continue with",
  "social.continueCustom": "Continue with {{adapter}}",
  "social.email": "Email",
  "social.email-continue": "Continue with Email",
  "social.email-new": "name@example.com",
  "social.passwordless-cta": "Continue",
  "social.passwordless-login": "Login",
  "social.passwordless-title": "Email or Phone",
  "social.phone": "Phone",
  "social.policy": "We do not store any data related to your social logins.",
  "social.sms": "Mobile",
  "social.sms-continue": "Continue with Mobile",
  "social.sms-invalid-number": "Invalid phone number",
  "social.sms-placeholder-text": "E.g.:",
  "social.view-less": "View less",
  "social.view-less-socials": "View less socials",
  "social.view-more": "View more",
  "social.view-more-socials": "View more socials"
};
var en = {
  modal: modal
};

export { en as default, modal };
